var render = function render(){var _vm=this,_c=_vm._self._c;return _c('figure',{staticClass:"figure"},[(_vm.isCaptionBottom)?_vm._t("content"):_vm._e(),_vm._v(" "),(!!_vm.$slots.caption)?_c('figcaption',{staticClass:"figure__caption",class:`figure__caption--${_vm.captionPosition}`},[_vm._t("caption")],2):_vm._e(),_vm._v(" "),(_vm.isCaptionTop)?_vm._t("content"):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }